export const Constants = {
  TAG_NAME: 'pop-pc-table-wrapper-component',
  nestedComponents: {
    PERFORMANCE_TABLE: 'pop-pc-performance-table-component',
    PERFORMANCE_TILES: 'pop-pc-performance-tiles-component',
    POPOVER: 'pop-product-center-popover',
    NOTIFICATION_ERROR: 'beacon-notification',
  },
  TABLE_TAB_INDEX: {
    PERFORMANCE: 1,
    PRICE: 2,
    ESG: 3,
    DOCUMENTS: 4,
  },
  TILES_TAB_INDEX: {
    ONE_YEAR: 1,
    THREE_YEARS: 2,
    FIVE_YEARS: 3,
    TEN_YEARS: 4,
    SINCE_INCEPTION: 5,
  },
  RESIZE_EVENT: 'resize',
  UPDATE_URL_EVENT: 'update-url',
  CUSTOM_CLASSES: {
    HEADER_ALIGNMENT: 'custom-header-alignment',
  },
  FUND_FIELD: {
    APIR: 'apir',
    BASECURRENCYNAME: 'baseCurrencyName',
    FUNDNAME: 'fundName',
    SHARECLASS: 'shareClass',
    VEHICLETYPENAME: 'vehicleTypeName',
    ISIN: 'isin',
  },
  TABLE_FIELD: {
    PERFORMANCE: 'performance',
    PRICING: 'pricing',
    ESG: 'esg',
    DOCUMENTS: 'documents',
    CUMULATIVE_CHART: 'cumulativeChart',
  },
  ICON_SLOT: 'icon',
  PREFIX_SLOT: 'prefix',
  SUFFIX_SLOT: 'suffix',
  CHEVRON_CUSTOM_CLASS: 'custom-chevron-down',
  SORT_DIRECTION_DSC_CUSTOM_CLASS: 'sort-desc',
  PRODUCT_NAME_COLUMN_ID: 'product-name',
  TRANSLATION_KEYS: {
    PRODUCT_EXPLORER: 'heading.product_explorer',
    SHOWING_PRODUCTS: 'heading.showing_products',
    TABS: {
      PERFORMANCE: 'tabs.performance',
      PRICE: 'tabs.price',
      ESG: 'tabs.esg',
      DOCUMENTS: 'tabs.documents',
    },
    FUND_RETURN: {
      ONE_YEAR: 'fund_return.one_year',
      THREE_YEARS: 'fund_return.three_years',
      FIVE_YEARS: 'fund_return.five_years',
      TEN_YEARS: 'fund_return.ten_years',
      SINCE_INCEPTION: 'fund_return.since_inception',
    },
    APIR: 'apir',
    ANNUALISED: 'fund_return.annualised',
    CURRENCY: 'currency',
    PRODUCT_NAME: 'product_name',
    PRODUCT_TYPE: 'product_type',
    SHARE_CLASS: 'share_class',
    CLASS: 'class',
    SORT_BY: 'sort_by',
    PERFORMANCE_TILE_TITLE: 'performance_tile_title',
    SORT: {
      SORT: 'sort.sort',
      SORT_ASC: 'sort.sort_asc',
      SORT_DSC: 'sort.sort_dsc',
    },
    ACTIONS: {
      DOWNLOAD: 'actions.download',
      SELECT_ALL: 'actions.select_all',
      DESELECT_ALL: 'actions.deselect_all',
    },
    NOTICE: 'notice',
    VIEWS: {
      TABLE: 'views.table',
      CHART: 'views.chart',
    },
  },
  DEFAULT_SORT_BY_DROP_DOWN_OPTION: {
    option: 'Share Class',
    value: 'shareClass',
  },
  ATTRIBUTES: {
    INDEX: 'index',
    SORT_VALUE: 'sort-value',
  },
  LOCALE: {
    EN_AU: 'en-AU',
  },
  CURRENCY: {
    AUD: 'AUD',
  },
  DATE_FORMATS: {
    MEDIUM_DATE_FORMAT: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
  DOCUMENT_FORMATS: {
    PDF: 'PDF',
    ARIA_LABEL_DESC: 'Opens in a new window',
  },
  TOOLTIP: 'Tooltip',
  TOOLTIP_LABEL: 'Click for a popover with more information',
  SORT_BUTTON_ID: 'sort-by-sort-button',
  CUSTOM_NO_VALUE_SYMBOL: '-',
  EVENTS: {
    CLICK: 'click',
    FILTER_UPDATE: 'filter-update',
  },
  DOWNLOAD_EXPORT_ERROR: {
    TITLE: 'Error',
    DESCRIPTION:
      'No products selected. Please select at least one product to enable the download feature.',
  },
  UTILS: {
    ANALYTICS: {
      DATA_METRICS_LINK_TEXT: 'data-metrics-link-text',
    },
    PROPERTIES: {
      COMPONENT_OBJECT: 'componentObject',
      SORT_BY_DROPDOWN_VALUE: 'sortByDropdownValue',
      SORT_DIRECTION_STATE: 'sortDirectionState',
      FILTERED_PRODUCTS: 'filteredProducts',
    },
    BEACON_TABLE_HEADER_SELECTOR: `[beacon-tag-name="beacon-table-header"]`,
    BEACON_TABLE_HEADER_ID_SELECTOR: `beacon-table-header#`,
    BEACON_TABLE_HEADER_SORT_SELECTOR: `[beacon-tag-name="beacon-table-header"]:not([sort-inactive])`,
    URL_PARAMS: {
      VIEW: 'view',
    },
  },
  MODAL_PREFIX: '-modal',
  CLASS: 'Class',
} as const;
